import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface GetEncounterFilesParams {
  patientId: string;
  motherEncounterId: string;
}

interface FileItem {
  documentReferenceId: string;
  fileUrl: string;
}

interface GetEncounterFilesResponse {
  files: FileItem[];
}

export const useGetEncounterFiles = ({
  patientId,
  motherEncounterId,
}: GetEncounterFilesParams) => {
  return useApi<GetEncounterFilesResponse>({
    queryOptions: {
      enabled: Boolean(motherEncounterId && patientId),
      queryFn: async () => {
        const response = await axiosInstance.get<GetEncounterFilesResponse>(
          `/charting/encounter-charting/${motherEncounterId}/files`,
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.EncounterFiles({
        patientId,
        motherEncounterId,
      }),
    },
  });
};
